import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import './Activities.css';

const Activities = () => {
    const { language } = useLanguage();
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedActivity, setSelectedActivity] = useState(null);

    useEffect(() => {
        const fetchActivities = async () => {
            try {
                const response = await fetch('https://admins.mahaviharahlegu.org/api/activities.php', {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'omit',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    referrer: 'https://www.mahaviharahlegu.org/',
                    referrerPolicy: 'strict-origin-when-cross-origin'
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch activities');
                }

                const data = await response.json();
                if (data.success) {
                    setActivities(data.data);
                } else {
                    throw new Error(data.error || 'Failed to fetch activities');
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchActivities();
    }, []);

    const handleSeeMore = (activity) => {
        setSelectedActivity(activity);
    };

    const closeModal = () => {
        setSelectedActivity(null);
    };

    if (loading) {
        return (
            <div className="activities-container">
                <div className="loading-spinner">Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="activities-container">
                <div className="error-message">{error}</div>
            </div>
        );
    }

    return (
        <div className="activities-container">
            <div className="activities-header">
                <h1>{language === 'en' ? 'Latest Activities' : 'နောက်ဆုံးရ လုပ်ငန်းများ'}</h1>
                <p>{language === 'en' ? 'Stay updated with our latest events and activities' : 'ကျွန်ုပ်တို့၏ နောက်ဆုံးရ လုပ်ငန်းများကို သိရှိရန်'}</p>
            </div>

            <div className="activities-grid">
                {activities.map((activity) => (
                    <div key={activity.id} className="activity-card">
                        <div className="activity-image-container">
                            <img
                                src={`https://admins.mahaviharahlegu.org/${activity.image_path}`}
                                alt={activity.title}
                                className="activity-image"
                                loading="lazy"
                            />
                        </div>
                        <div className="activity-content">
                            <h2>{activity.title}</h2>
                            <p className="activity-date">
                                {new Date(activity.created_at).toLocaleDateString()}
                            </p>
                            <p className="activity-excerpt">
                                {activity.excerpt}
                            </p>
                            <button 
                                className="see-more-btn"
                                onClick={() => handleSeeMore(activity)}
                            >
                                {language === 'en' ? 'See More' : 'ပိုမိုကြည့်ရှုရန်'}
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {selectedActivity && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <button className="modal-close" onClick={closeModal}>×</button>
                        <div className="modal-header">
                            <h2>{selectedActivity.title}</h2>
                            <p className="modal-date">
                                {new Date(selectedActivity.created_at).toLocaleDateString()}
                            </p>
                        </div>
                        <div className="modal-body">
                            <img
                                src={`https://admins.mahaviharahlegu.org/${selectedActivity.image_path}`}
                                alt={selectedActivity.title}
                                className="modal-main-image"
                            />
                            <div className="modal-description">
                                {selectedActivity.description}
                            </div>
                            {selectedActivity.additional_photos && selectedActivity.additional_photos.length > 0 && (
                                <div className="modal-gallery">
                                    <h3>{language === 'en' ? 'Additional Photos' : 'ထပ်ဆင့် ဓာတ်ပုံများ'}</h3>
                                    <div className="modal-gallery-grid">
                                        {selectedActivity.additional_photos.map((photo, index) => (
                                            <img
                                                key={index}
                                                src={`https://admins.mahaviharahlegu.org/${photo}`}
                                                alt={`${selectedActivity.title} - Photo ${index + 1}`}
                                                className="modal-gallery-image"
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Activities; 